// Default delay used for popups in category menu (in miliseconds)
export const DEFAULT_POPUP_OPEN_DELAY = 175;
